
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import CompanyFollowUpRecordPageList from "../../CompanyFollowUpRecord/CompanyFollowUpRecordPageList.vue";
import { EnumCompanyType } from "@/models.machine/EnumCompanyType";
import MiezzPageList from "@/models/MiezzPageList";
import DtoPageListSearchCompanyFollowUpRecord from "@/models.machine/DtoPageListSearchCompanyFollowUpRecord";
import DtoListItemCompanyFollowUpRecord from "@/models.machine/DtoListItemCompanyFollowUpRecord";
@Options({
  components: {
    CompanyFollowUpRecordPageList,
  },
})
export default class SupplierCompanyFollowUpRecordPageList extends Vue {
  type = EnumCompanyType.Supplier;
  list = new MiezzPageList<
    DtoPageListSearchCompanyFollowUpRecord,
    DtoListItemCompanyFollowUpRecord,
    string
  >("SupplierManagement_FollowUpRecord");
}
